import React, { Component } from 'react'
import classes from './App.scss'
import { Route, Switch } from 'react-router-dom'

import Layout from './hoc/Layout/Layout'
import AuthLayout from './hoc/AuthLayout/AuthLayout'
import Home from './containers/PageContent/Home/Home'
import NotFound from './components/NotFound/NotFound'
import Company from './containers/PageContent/SetupData/Company/Company'
import User from './containers/PageContent/Manage/User/User'
import Role from './containers/PageContent/Manage/Role/Role'
import SetupForm from './containers/PageContent/SetupData/SetupForm/SetupForm'
import SetupPositionGroup from './containers/PageContent/SetupData/SetupPositionGroup/SetupPositionGroup'
import SetupStructure from './containers/PageContent/SetupData/SetupStructure/SetupStructure'
import SetupCompetencyScore from './containers/PageContent/SetupData/SetupCompetencyScore/SetupCompetencyScore'
import SetupLevel from './containers/PageContent/SetupData/SetupLevel/SetupLevel'
import KpiType from './containers/PageContent/SetupData/KpiType/KpiType'
import Uom from './containers/PageContent/SetupData/Uom/Uom'
import PasswordPolicy from './containers/PageContent/Settings/PasswordPolicy/PasswordPolicy'
import EmailServer from './containers/PageContent/Settings/EmailServer/EmailServer'
import SetupPosition from './containers/PageContent/SetupData/SetupPosition/SetupPosition'
import SetupPerspective from './containers/PageContent/SetupData/SetupPerspective/SetupPerspective'
import SetupOrg from './containers/PageContent/SetupData/SetupOrg/SetupOrg'
import SetupCriteria from './containers/PageContent/SetupData/SetupCriteria/SetupCriteria'
import AppraisalItem from './containers/PageContent/AppraisalItem/AppraisalItem'
import Profile from './containers/PageContent/Profile/Profile'
import PrivateRoute from './hoc/PrivateRoute/PrivateRoute'
import AuthRoute from './hoc/AuthRoute/AuthRoute'
import PermissionRoute from './hoc/PermissionRoute/PermissionRoute'
import { connect } from 'react-redux'
import SplashScreen from './components/SplashScreen/SplashScreen'
import SignOut from './containers/AuthPanel/SignOut/SignOut'
import Employee from './containers/PageContent/Employee/Employee'
import EmployeeDetail from './containers/PageContent/Employee/EmployeeDetail/EmployeeDetail'
import Individual from './containers/PageContent/Assignment/Individual/Individual'
import Corporate from './containers/PageContent/Assignment/Corporate/Corporate'
import AssignPage from './containers/PageContent/Assignment/AssignPage/AssignPage'
import ItemSelector from './containers/PageContent/Assignment/ItemSelector/ItemSelector'
import Appraisal from './containers/PageContent/Appraisal/AppraisalPage/Appraisal'
import ForceRank from './containers/PageContent/ForceRank/ForceRank'
import AppraisalResult from './containers/PageContent/Appraisal/AppraisalResult/AppraisalResult'
import SetupLevelGroup from './containers/PageContent/SetupData/SetupLevelGroup/SetupLevelGroup'
import SetupThresholdGroup from './containers/PageContent/SetupData/SetupThresholdGroup/SetupThresholdGroup'
import ReportDataEntry from './containers/PageContent/Report/DataEntry/DataEntry'
import ReportKpi from './containers/PageContent/Report/Kpi/Kpi'
import ReportAppraisal from './containers/PageContent/Report/Appraisal/Appraisal'
import ReportPerformanceForm from './containers/PageContent/Report/PerformanceForm/PerformanceForm'
import ReportAppraisalByOrg from './containers/PageContent/Report/AppraisalByOrg/AppraisalByOrg'
import ReportAppraisalByLevel from './containers/PageContent/Report/AppraisalByLevel/AppraisalByLevel'
import ReportAppraisalByJobKpi from './containers/PageContent/Report/AppraisalByJobKpi/AppraisalByJobKpi'
import ReportBonusSalary from './containers/PageContent/Report/BonusSalary/BonusSalary'
import UsageLog from './containers/PageContent/UsageLog/UsageLog'
import DashboardOverallPerformace from './containers/PageContent/Dashboard/DashboardOverallPerformace/DashboardOverallPerformace'
import DashboardPerformanceTrend from './containers/PageContent/Dashboard/PerformanceTrend/PerformanceTrend'
import DashboardPerformanceComparison from './containers/PageContent/Dashboard/PerformanceComparison/PerformanceComparison'
import DashboardBranchPerformance from './containers/PageContent/Dashboard/DashboardBranchPerformance/DashboardBranchPerformance'
import GradeCriteria from './containers/PageContent/SetupData/GradeCriteria/GradeCriteria'
import ImportSalary from './containers/PageContent/ImportSalary/ImportSalary'
import VerticalForceRank from './containers/PageContent/VerticalForceRank/VerticalForceRank'
import HorizontalForceRank from './containers/PageContent/HorizontalForceRank/HorizontalForceRank'
import HorizontalForceRankBoard from './containers/PageContent/HorizontalForceRankBoard/HorizontalForceRankBoard'
import ForceRankGroup from './containers/PageContent/SetupData/ForceRankGroup/ForceRankGroup'
import Feedback from './containers/PageContent/Feedback/Feedback'
import FeedbackReport from './containers/PageContent/Feedback/Report/FeedbackReport'
class App extends Component {
  render() {
    if (this.props.loading) {
      return <SplashScreen />
    }
    return (
      <div className={classes.App}>
        <Switch>
          <AuthRoute exact path='/login' component={AuthLayout} />
          <PrivateRoute
            exact
            path='/*'
            render={() => (
              <Layout>
                <Switch>
                  <Route path='/profile' component={Profile} urlCode={'profile'} />
                  <PermissionRoute path='/manage/user' component={User} urlCode={'user'} />
                  <PermissionRoute path='/manage/role' component={Role} urlCode={'role'} />
                  <PermissionRoute path='/setup/company' component={Company} urlCode={'company'} />
                  <PermissionRoute
                    path='/setup/organization'
                    component={SetupOrg}
                    urlCode={'organization'}
                  />
                  <PermissionRoute path='/setup/kpi' component={KpiType} urlCode={'kpi_type'} />
                  <PermissionRoute path='/setup/uom' component={Uom} urlCode={'uom'} />
                  <PermissionRoute
                    path='/setup/position'
                    component={SetupPosition}
                    urlCode={'position'}
                  />
                  <PermissionRoute
                    path='/setup/threshold_group'
                    component={SetupThresholdGroup}
                    urlCode={'threshold_group'}
                  />
                  <PermissionRoute
                    path='/setup/perspective'
                    component={SetupPerspective}
                    urlCode={'perspective'}
                  />
                  <PermissionRoute
                    path='/setup/position_group'
                    component={SetupPositionGroup}
                    urlCode={'position_group'}
                  />
                  <PermissionRoute
                    path='/report/usage_log'
                    component={UsageLog}
                    urlCode={'usage_log'}
                  />
                  <PermissionRoute
                    path='/setup/competency_score'
                    component={SetupCompetencyScore}
                    urlCode={'competency_score'}
                  />
                  <PermissionRoute path='/setup/form' component={SetupForm} urlCode={'form'} />
                  <PermissionRoute
                    path='/setup/structure'
                    component={SetupStructure}
                    urlCode={'structure'}
                  />
                  <PermissionRoute path='/setup/level' component={SetupLevel} urlCode={'level'} />
                  <PermissionRoute
                    path='/setup/level_group'
                    component={SetupLevelGroup}
                    urlCode={'level_group'}
                  />
                  <PermissionRoute
                    path='/setup/criteria'
                    component={SetupCriteria}
                    urlCode={'criteria'}
                  />
                  <PermissionRoute
                    path='/setup/perspective'
                    component={SetupPerspective}
                    urlCode={'perspective'}
                  />
                  <PermissionRoute
                    path='/setup/grade_criteria'
                    component={GradeCriteria}
                    urlCode={'grade_criteria'}
                  />
                  <PermissionRoute
                    path='/setup/force_rank_group'
                    component={ForceRankGroup}
                    urlCode={'force_rank_group'}
                  />
                  <PermissionRoute path='/feedback' component={Feedback} urlCode={'feedback'} />
                  {/* <PermissionRoute path="/adjust" component={Adjust} urlCode={'adjust'} /> */}
                  <PermissionRoute
                    path='/appraisal_item'
                    component={AppraisalItem}
                    urlCode={'item'}
                  />
                  <PermissionRoute
                    path='/report/data_entry'
                    component={ReportDataEntry}
                    urlCode={'report_data_entry'}
                  />
                  <PermissionRoute
                    path='/report/kpi'
                    component={ReportKpi}
                    urlCode={'report_kpi'}
                  />
                  <PermissionRoute
                    path='/report/performance_form'
                    component={ReportPerformanceForm}
                    urlCode={'report_performance_form'}
                  />
                  <PermissionRoute
                    path='/report/appraisalbyjobkpi'
                    component={ReportAppraisalByJobKpi}
                    urlCode={'report_appraisal_by_job_kpi'}
                  />
                  <PermissionRoute
                    path='/report/appraisalbylevel'
                    component={ReportAppraisalByLevel}
                    urlCode={'report_appraisal_by_level'}
                  />
                  <PermissionRoute
                    path='/report/appraisalbyorg'
                    component={ReportAppraisalByOrg}
                    urlCode={'report_appraisal_by_org'}
                  />
                  <PermissionRoute
                    path='/report/appraisal'
                    component={ReportAppraisal}
                    urlCode={'report_appraisal'}
                  />
                  <PermissionRoute
                    path='/report/bonussalary'
                    component={ReportBonusSalary}
                    urlCode={'report_bonus_salary'}
                  />
                  <PermissionRoute
                    path={'/feedback_report'}
                    component={FeedbackReport}
                    urlCode={'feedback_report'}
                  />
                  <PermissionRoute
                    path='/assignment/individual'
                    component={Individual}
                    urlCode={'assignment'}
                  />
                  <PermissionRoute
                    path='/assignment/corporate'
                    component={Corporate}
                    urlCode={'assignment'}
                  />
                  <PermissionRoute
                    path='/assignment/items'
                    component={ItemSelector}
                    urlCode={'assignment'}
                  />
                  <PermissionRoute
                    path='/assignment/:id(\d+|assign)'
                    component={AssignPage}
                    urlCode={'assignment'}
                  />
                  <PermissionRoute
                    path='/appraisal/:id(\d+)'
                    component={AppraisalResult}
                    urlCode={'appraisal'}
                  />
                  <PermissionRoute path='/appraisal' component={Appraisal} urlCode={'appraisal'} />
                  <PermissionRoute
                    path='/dashboard/overall_performance'
                    component={DashboardOverallPerformace}
                    urlCode={'dashboard_overall_performance'}
                  />
                  <PermissionRoute
                    path='/dashboard/dashboard_performance_trend'
                    component={DashboardPerformanceTrend}
                    urlCode={'dashboard_performance_trend'}
                  />
                  <PermissionRoute
                    path='/dashboard/performance_comparison'
                    component={DashboardPerformanceComparison}
                    urlCode={'dashboard_performance_comparison'}
                  />
                  <PermissionRoute
                    path='/dashboard/branch_performance'
                    component={DashboardBranchPerformance}
                    urlCode={'dashboard_branch_performance'}
                  />
                  <PermissionRoute
                    path='/employee'
                    urlCode={'employee'}
                    render={props => {
                      return (
                        <Switch>
                          <Route
                            exact
                            path='/employee/'
                            component={() => <Employee pagePermission={props.pagePermission} />}
                          />
                          <Route
                            path='/employee/:id(\d+|add)'
                            component={() => (
                              <EmployeeDetail pagePermission={props.pagePermission} />
                            )}
                          />
                          <Route component={NotFound} />
                        </Switch>
                      )
                    }}
                  />
                  <PermissionRoute
                    path='/force_rank'
                    component={ForceRank}
                    urlCode={'force_rank'}
                  />
                  <PermissionRoute
                    path='/force_rank_vertical'
                    component={VerticalForceRank}
                    urlCode={'force_rank_vertical'}
                  />
                  <PermissionRoute
                    path='/force_rank_horizontal'
                    component={HorizontalForceRank}
                    urlCode={'force_rank_horizontal'}
                  />
                  <PermissionRoute
                    path='/force_rank_horizontal_board'
                    component={HorizontalForceRankBoard}
                    urlCode={'force_rank_horizontal_board'}
                  />
                  <PermissionRoute
                    path='/import_salary'
                    component={ImportSalary}
                    urlCode={'import_salary'}
                  />
                  <PermissionRoute path='/adjust' component={Layout} urlCode={'adjust'} />
                  <PermissionRoute
                    path='/setting/password_policy'
                    component={PasswordPolicy}
                    urlCode={'password_policy'}
                  />
                  <PermissionRoute path='/setting/LDAP' component={Layout} urlCode={'ldap'} />
                  <PermissionRoute
                    path='/setting/e_mail_server'
                    component={EmailServer}
                    urlCode={'e_mail_server'}
                  />
                  <PermissionRoute
                    path='/setting/data_integration'
                    component={Layout}
                    urlCode={'data_integration'}
                  />
                  <Route path='/logout' component={SignOut} />
                  <Route exact path='/' component={Home} />
                  <Route path='/*' component={NotFound} />
                </Switch>
              </Layout>
            )}
          />
          <Route component={NotFound} />
        </Switch>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    loading: state.auth.loading
  }
}

export default connect(mapStateToProps)(App)
